import { render, staticRenderFns } from "./BranchSubsetEditor.vue?vue&type=template&id=4b8e4bb1&scoped=true&"
import script from "./BranchSubsetEditor.vue?vue&type=script&lang=js&"
export * from "./BranchSubsetEditor.vue?vue&type=script&lang=js&"
import style0 from "./BranchSubsetEditor.vue?vue&type=style&index=0&id=4b8e4bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e4bb1",
  null
  
)

export default component.exports